export { default } from './cardholder-agreement';
export { getStaticPaths, getStaticProps } from '../../utils/DynamicRoutes';
